import styles from './Audits.module.css';
import { site } from '../content/site.js';
import Reveal from './Reveal.jsx';

export default function Audits() {
  const a = site.audits;
  return (
    <section className={styles.audits} id="audits">
      <header className="section-head">
        <span className="num" aria-hidden="true">{a.num}</span>
        <h2>{a.title}</h2>
        <p className="meta">{a.meta}</p>
      </header>

      <div className={styles.intro}>
        <Reveal className={styles.pitch}>
          {a.pitchTitle.split('human eyes').map((chunk, i, arr) =>
            i < arr.length - 1 ? (
              <span key={i}>
                {chunk}
                <span className={styles.accent}>human eyes</span>
              </span>
            ) : (
              <span key={i}>{chunk}</span>
            )
          )}
        </Reveal>
        <div className={styles.pitchBody}>
          <Reveal delay={0.08}>{a.pitchBody}</Reveal>
          <Reveal delay={0.16} className={styles.pitchSmall}>
            {a.pitchSmall}
          </Reveal>
        </div>
      </div>

      <div className={styles.cta}>
        <span>Written by humans · one client at a time</span>
        <a
          href={a.ctaUrl}
          target="_blank"
          rel="noreferrer noopener"
        >
          Visit auditbyhumans.io →<span className="sr-only"> (opens in new tab)</span>
        </a>
      </div>
    </section>
  );
}
